"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useRef } from "react";
import { useLayout } from "../layout/LayoutContext";
import { useWave } from "@/hooks/useWave";
import type { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveTabsMeme from "./MyStreamWaveTabsMeme";
import MyStreamWaveTabsDefault from "./MyStreamWaveTabsDefault";
import useDeviceInfo from "../../../../hooks/useDeviceInfo";
import type { WaveViewMode } from "@/hooks/useWaveViewMode";
interface MyStreamWaveTabsProps {
  readonly wave: ApiWave;
  readonly viewMode: WaveViewMode;
  readonly onToggleViewMode: () => void;
  readonly showGalleryToggle: boolean;
}
export const MyStreamWaveTabs: React.FC<MyStreamWaveTabsProps> = t0 => {
  const $ = _c(15);
  const {
    wave,
    viewMode,
    onToggleViewMode,
    showGalleryToggle
  } = t0;
  const {
    isMemesWave
  } = useWave(wave);
  const {
    registerRef
  } = useLayout();
  const {
    isApp
  } = useDeviceInfo();
  const tabsElementRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== isApp || $[1] !== registerRef) {
    t1 = () => {
      if (isApp) {
        registerRef("tabs", null);
      }
    };
    t2 = [isApp, registerRef];
    $[0] = isApp;
    $[1] = registerRef;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== registerRef) {
    t3 = element => {
      tabsElementRef.current = element;
      registerRef("tabs", element);
    };
    $[4] = registerRef;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const setTabsRef = t3;
  if (isApp) {
    return null;
  }
  let t4;
  if ($[6] !== isMemesWave || $[7] !== onToggleViewMode || $[8] !== showGalleryToggle || $[9] !== viewMode || $[10] !== wave) {
    t4 = <div className="tw-w-full tw-bg-iron-950"><div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-x-3">{isMemesWave ? <MyStreamWaveTabsMeme wave={wave} /> : <MyStreamWaveTabsDefault wave={wave} viewMode={viewMode} onToggleViewMode={onToggleViewMode} showGalleryToggle={showGalleryToggle} />}</div></div>;
    $[6] = isMemesWave;
    $[7] = onToggleViewMode;
    $[8] = showGalleryToggle;
    $[9] = viewMode;
    $[10] = wave;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== setTabsRef || $[13] !== t4) {
    t5 = <div className="tw-flex-shrink-0" ref={setTabsRef} id="tabs-container">{t4}</div>;
    $[12] = setTabsRef;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};